import { RouteObject } from "react-router-dom";
import { HomePage, LoginPage, JoinPage, AuthPage, SubscriptionsPage, SubscriptionManagementPage, ChatsPage, ChatPage, SegmentsPage, SegmentPage } from "./lazyPages";

export const ROUTES: RouteObject[] =  [
    {
        index: true,
        element: <HomePage/>,
    },
    {
        path: 'auth',
        element: <AuthPage/>
    },
    {
        path: 'login',
        element: <LoginPage/>
    },
    {
        path: 'join',
        element: <JoinPage/>
    },
    {
        path: 'automatizations',
        children: [
            {
                index: true,
                element: <SubscriptionsPage/>
            },
            {
                path: 'new',
                element: <SubscriptionManagementPage />
            },
            {
                path: ':id',
                element: <SubscriptionManagementPage />
            }
        ]
    },
    {
        path: 'chats',
        children: [
            {
                index: true,
                element: <ChatsPage/>
            },
            {
                path: ':id',
                element: <ChatPage/>
            }
        ]
    },
    {
        path: 'segments',
        children: [
            {
                index: true,
                element: <SegmentsPage/>
            },
            {
                path: 'new',
                element: <SegmentPage/>
            },
            {
                path: ':id',
                element: <SegmentPage/>
            },
        ]
    }
]